import type { HyperEntityConfig } from "@shared/backend/hyper-entity.decorator";
import { type FutureNotification } from "./entity";

export const FutureNotificationEntityConfig: HyperEntityConfig<FutureNotification> =
  {
    allowApiCrud: false,
    allowApiRead: false,
  };
